<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :title="title"
      ref="grid"
      :actions="actions"
      :beforeSetupGrid="beforeSetupGrid"
      :selectionEnabled="true"
      :onRowClicked="onRowClicked"
      navigationPath="onRowClicked"
      navigationField="onRowClicked"
    ></dx-grid>

    <v-dialog persistent v-model="deleteDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-0"
          >Delete Registration Forms</v-card-title
        >
        <div class="font-weight-regular">
          The {{ selected.length }} selected Registration Forms will be deleted
        </div>
        <v-card-actions class="mr-0 mt-3">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="deleteDialog = false"
            >Cancel</v-btn
          >
          <v-btn :loading="processing" color="success" @click="deleteRegForms">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="addRegFormDialog" max-width="600">
      <voting-reg-form
        ref="regFormDialog"
        :form="rowClicked"
        :student="clickedStudent"
        :person="clickedPerson"
        :reload="reload"
        :close="closeAddRegistrationForm"
      ></voting-reg-form>
    </v-dialog>
  </div>
</template>

<script>
import votingRegForm from "./VotingRegForm.vue";

export default {
  components: {
    votingRegForm,
  },
  data: () => ({
    title: "Voting Regstration Form",

    actions: [],
    userBranch: "",
    url: "",
    regID: "",
    processing: false,

    selected: [],
    deleteDialog: false,
    addRegFormDialog: false,
    rowClicked: {},

    clickedStudent: {},
    clickedPerson: {},

    columns: [
      {
        field: "statusIcon",
        isIcon: true,
        template: "icon",
        alignment: "center",
        visible: true,
        allowFiltering: false,
        allowHeaderFiltering: false,
        allowHiding: false,
        allowSearch: false,
        cssClass: "width-25",
        headerFilter: {
          allowSearch: false,
          groupInterval: undefined,
          height: undefined,
          searchMode: "contains",
        },
        icon: (value) => {
          switch (value) {
            case "Matched":
              return "mdi-check-decagram";
            case "Completed":
              return "mdi-check-circle";
            case "Submitted":
              return "mdi-send";
            case "Pending":
              return "mdi-clock";
            default:
              return "";
          }
        },
        iconColor: (value) => {
          switch (value) {
            case "Matched":
              return "#4caf50";
            case "Completed":
              return "#388e3c";
            case "Submitted":
              return "#1976d2";
            case "Pending":
              return "#fdb400";
            default:
              return "#aeb8bf";
          }
        },
      },
      {
        label: "Status",
        field: "status",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      // {
      //     label: "ID",
      //     field: "id",
      //     visible: true,
      //     filterValues: [],
      //     filterValue: null,
      //     selectedFilterOperation: null,
      // },
      {
        label: "Name",
        field: "name",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Address",
        field: "address",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Student ID",
        field: "studentID",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Person ID",
        field: "personID",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Parent ID",
        field: "parentId",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "enteredOn",
        label: "Entered On",
        type: "date",
        format: "",
        visible: true,
        filterType: "",
        format: "MM/dd/yyyy hh:mm:ss a",
        sortOrder: "desc",
        sortIndex: 0,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Type",
        field: "type",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Matched To DOE",
        field: "isMatchedToDOE",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "DOE ID",
        field: "matchedToDoeID",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "dob",
        label: "DOB",
        type: "date",
        format: "",
        visible: true,
        filterType: "",
        format: "MM/dd/yyyy",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "dateSubmitted",
        label: "Date Submitted",
        type: "date",
        format: "",
        visible: true,
        filterType: "",
        format: "MM/dd/yyyy",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Note",
        field: "note",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Entered By",
        field: "enteredBy",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Student Name",
        field: "studentName",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Student Phone",
        field: "studentPhone",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Student Source",
        field: "source",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "ANSL Name",
        field: "personName",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],
  }),
  async created() {},
  beforeDestroy() {},
  methods: {
    async beforeSetupGrid() {
      this.actions.push({
        text: "Delete",
        action: this.openDeleteDialog,
        showOnSelection: true,
      });

      this.url = "votingRegstrationFormStatus";
    },
    async onRowClicked(row) {
      this.rowClicked = row;

      this.clickedStudent = {};
      this.clickedPerson = {};

      if (row.studentID) {
        this.clickedStudent = await this.$http.get(
          "api/ygStudents/getByID?id=" + row.studentID
        );
      } else {
        this.clickedPerson = await this.$http.get(
          "api/voting/getByID?personID=" + row.personID
        );
      }

      this.addRegFormDialog = true;

      if (this.$refs.regFormDialog) {
        this.$refs.regFormDialog.resetValidation();
      }
    },
    openDeleteDialog() {
      this.selected = this.$refs.grid.getSelectedRowsData();

      this.deleteDialog = true;
    },
    closeAddRegistrationForm() {
      this.addRegFormDialog = false;
    },
    reload() {
      this.$refs.grid.reloadGrid();
    },
    async deleteRegForms() {
      try {
        this.processing = true;

        const ids = this.selected.map((s) => s.id);

        await this.$http.post("api/votingRegstrationFormStatus/delete", ids);

        this.$notify({
          text: "Registration Form Deleted",
          group: "notification",
          type: "success",
        });

        this.processing = false;
        this.deleteDialog = false;

        this.$refs.grid.reloadGrid();
      } catch (e) {
        this.processing = false;
      }
    },
  },
};
</script>
<style>
[v-cloak] {
  display: none;
}
.v-btn__content {
  color: unset;
}
.accounts-search.container {
  padding-top: 0px;
}
.yg-student-account-match {
  border: 2px solid #4caf50;
}
</style>
